export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SWAP_TABS = "SWAP_TABS";
export const ADD_SETTING_VIEW_EDIT = "ADD_SETTING_VIEW_EDIT";
export const REMOVE_SETTING_VIEW_EDIT = "REMOVE_SETTING_VIEW_EDIT";
export const ADD_DIAMOND_VIEW_EDIT = "ADD_DIAMOND_VIEW_EDIT";
export const REMOVE_DIAMOND_VIEW_EDIT = "REMOVE_DIAMOND_VIEW_EDIT";
